import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '/app/environments/environment';
import { Observable, of } from 'rxjs';
import { map, expand, takeWhile, reduce, toArray, mergeMap } from 'rxjs/operators';
import { LapseEvaluationClassification, Alarm, AlarmsResponse } from '../models/alarm.model';
import eventosJson from '/assets/evento.json'; // Si está local

import { Evento } from '../models/evento.model';



@Injectable({
  providedIn: 'root',
})
export class AlarmsService {
  constructor(private httpClient: HttpClient,

  ) {
    this.eventos = eventosJson.eventos.map(e => ({
      ...e,
      mapeaid: e.mapaid
    }));
  }
  private eventos: Evento[] = [];

  // ================== ALARMAS EXISTENTES ==================
  // public getAlarms(monitorId?: string, page: number = 0, size: number = 15): Observable<AlarmsResponse> {
  //   let url = environment.api + '/alarms';
  //   let params = new HttpParams().set('page', page.toString()).set('size', size.toString());
  //   // debug log removed
  //   if (monitorId) {
  //     url += `/${monitorId}/monitor`;
  //     params = params.set('monitorId', monitorId);
  //   }
  //   return this.httpClient.get<AlarmsResponse>(url, { params });
  // }




  public getAlarms(
    monitorId?: string,
    page: number = 0,
    size: number = 15,

// eventIdToFilter

    filters?: {
      status?: string;
      riskEvaluation?: number;
      startDate?: string;   // ISO string
      endDate?: string;     // ISO string
      dateRangePreset?: string;
      resolvedBy?: string;
      reviewingBy?: string;
      assetId?: string;
      eventId?: string; // Nuevo filtro para eventId

    }
  ): Observable<AlarmsResponse> {



    

    let url = environment.api + '/alarms';
    let params = new HttpParams();

    if (monitorId) {
      url += `/${monitorId}/monitor`;
      // OJO: no agregues monitorId como parámetro cuando va en la URL
    }

    // === Agregar filtros dinámicos ===
    if (filters) {
      if (filters.status) {
        params = params.set('status', filters.status);
      }

      if (filters.riskEvaluation !== undefined && filters.riskEvaluation !== null) {
        params = params.set('riskEvaluation', filters.riskEvaluation.toString());
      }

      if (filters.startDate) {
        params = params.set('startDate', filters.startDate);
      }

      if (filters.endDate) {
        params = params.set('endDate', filters.endDate);
      }

      if (filters.dateRangePreset) {
        params = params.set('dateRangePreset', filters.dateRangePreset);
      }


      if (filters.resolvedBy) {
        params = params.set('resolvedBy', filters.resolvedBy);
      }

      if (filters.reviewingBy) {
        params = params.set('reviewingBy', filters.reviewingBy);
      }

      if (filters.assetId) {
        params = params.set('assetId', filters.assetId);
      }

      if (filters.eventId) {
        params = params.set('eventId', filters.eventId);
      }

    }

    // page y size al final de la URL
    params = params.set('page', page.toString()).set('size', size.toString());

    return this.httpClient.get<AlarmsResponse>(url, { params });
  }

  /**
   * Exporta alarmas en CSV. Construye los mismos parámetros que `getAlarms`.
   * Devuelve un Blob con el contenido CSV.
   */
  public exportAlarmsCsv(
    monitorId?: string,
    filters?: {
      status?: string;
      riskEvaluation?: number;
      startDate?: string; // ISO string
      endDate?: string; // ISO string
      dateRangePreset?: string;
      resolvedBy?: string;
      reviewingBy?: string;
    }
  ): Observable<Blob> {
    let url = environment.api + '/alarms/export/csv';
    // No enviar page/size ni el filtro 'status' según petición.
    let params = new HttpParams();

    if (monitorId) {
      params = params.set('monitorId', monitorId);
    }

    if (filters) {
      // Omitir filters.status intencionalmente
      if (filters.riskEvaluation !== undefined && filters.riskEvaluation !== null) params = params.set('riskEvaluation', filters.riskEvaluation.toString());
      if (filters.startDate) params = params.set('startDate', filters.startDate);
      if (filters.endDate) params = params.set('endDate', filters.endDate);
      if (filters.dateRangePreset) params = params.set('dateRangePreset', filters.dateRangePreset);
      if (filters.resolvedBy) params = params.set('resolvedBy', filters.resolvedBy);
      if (filters.reviewingBy) params = params.set('reviewingBy', filters.reviewingBy);
    }

    return this.httpClient.get(url, { params, responseType: 'blob' as 'blob' });
  }

  /**
   * Obtiene todas las alarmas del día actual, iterando por páginas de 100 elementos
   * @param monitorId ID del monitor (opcional)
   * @returns Observable con array de todas las alarmas del día
   */
  public getAllTodayAlarms(monitorId?: string): Observable<Alarm[]> {
    // Obtener fecha de hoy en formato ISO (YYYY-MM-DD)
    const today = new Date();
    const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999);

    const filters = {
      startDate: startOfDay.toISOString(),
      endDate: endOfDay.toISOString()
    };

    // Debug logging removed

    // Primera página
    return this.getAlarms(monitorId, 0, 100, filters).pipe(
      expand((response: AlarmsResponse) => {
        // Si hay más páginas, obtener la siguiente
        if (response.number < response.totalPages - 1) {
          const nextPage = response.number + 1;
          return this.getAlarms(monitorId, nextPage, 100, filters);
        } else {
          // No hay más páginas, retornar observable vacío
          return of({} as AlarmsResponse);
        }
      }),
      takeWhile((response: AlarmsResponse) => response.content !== undefined),
      map((response: AlarmsResponse) => response.content || []),
      reduce((acc: Alarm[], current: Alarm[]) => [...acc, ...current], []),
      map((allAlarms: Alarm[]) => {
        // Removed debug log
        return allAlarms;
      })
    );
  }





  public getAlarm(alarmId: string): Observable<Alarm> {
    const url = `${environment.api}/alarms/${alarmId}`;
    return this.httpClient.get<Alarm>(url);
  }

  public doClassification(classification: LapseEvaluationClassification, id: string): Observable<Alarm> {
    return this.httpClient.post<Alarm>(`${environment.api}/alarms/${id}/resolve`, classification);
  }

  public doBulkClassification(data: {
    alarmIds: string[];
    status: string;
    observations?: string;
  }, monitorId: string): Observable<any> {
    return this.httpClient.post<any>(`${environment.api}/alarms/bulk-resolve/${monitorId}`, data);
  }

  public doAttended(id: string, monitorId: string): Observable<Alarm> {
    return this.httpClient.post<Alarm>(`${environment.api}/alarms/${monitorId}/recognize/${id}`, {});
  }

  // ================== NUEVOS MÉTODOS DE EVENTOS ==================
  public getAllEventos(): Observable<Evento[]> {
    const sortedEventos = [...this.eventos].sort((a, b) =>
      a.desc_es.localeCompare(b.desc_es)
    );
    return of(sortedEventos);
  }


  // Obtener evento por eventoid
  public getEventoById(eventoid: number): Observable<Evento | undefined> {
    const evento = this.eventos.find(e => e.eventoid === eventoid);
    return of(evento);
  }

}
